import React from 'react';

import { useTranslation } from 'react-i18next';

const MentionsLegales = () => {

  const { t } = useTranslation();

  return (
    <div className={"strate footer2"} id={"mlStrate"}>
      <h1 dangerouslySetInnerHTML={{ __html: t("mentions_h1") }} />

      <div id={"ml_wrapper"}>

        <div className={"block"}>
          <h4 dangerouslySetInnerHTML={{ __html: t("mentions_siteedit") }} />

          <p>
            TLC Worldwide France<br />
            92 avenue de Wagram – 75017 Paris<br />
            N° SIREN : 491 414 306<br />
            N° SIRET : 491 414 306 00036<br />
            RCS : Paris B 491 414 306<br />
            SARL au capital social de : 150 000€<br />
            Numéro de TVA intracommunautaire :<br className={"d-lg-none"} /> FR 70 491 414 306<br />
            Adresse e-mail : <a href="mailto:bonjour@tlcmarketing.com?subject=Op%C3%A9ration%20Les%20Rendez-Vous%20Barri%C3%A8re">bonjour@tlcmarketing.com</a>
          </p>

        </div>
        <div className={"block"}>
          <h4 dangerouslySetInnerHTML={{ __html: t("mentions_pour_le_compte_de") }} />

          <p>
            Groupe Lucien Barrière<br />
            33 rue d’Artois – 75008 Paris<br />
            N° SIREN : 320 050 859<br />
            N° SIRET : 320 050 859 00109<br />
            RCS : Paris B 320 050 859<br />
            SA à conseil d’administration au capital social de :<br />
            1 215 144,68€<br />
            Numéro de TVA intracommunautaire : <br className={"d-lg-none"} />
            FR 29 320 050 859
          </p>
        </div>
        <div className={"block"}>
          <h4 dangerouslySetInnerHTML={{ __html: t("mentions_devby") }} />

          <p>
            Vertuelle / CBBC<br />
            29 boulevard de la Ferrage – CS 20005 – 06400 Cannes<br />
            N° SIREN : 843 171 331<br />
            N° SIRET : 843 171 331 00013<br />
            RCS : Cannes B 843 171 331<br />
            SARL unipersonnelle au capital social de : 5 000€<br />
            Numéro de TVA intracommunautaire : <br className={"d-lg-none"} />
            FR 94 843 171 331
          </p>

        </div>

        <div className={"smallBlock"} dangerouslySetInnerHTML={{ __html: t("mentions_end") }} />

      </div>
    </div>
  );
};

export default MentionsLegales;
